import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import moment from 'moment';
import { initReactI18next } from 'react-i18next';

import config from 'config';
import { Plugin } from './i18next-backend-plugin';
import { format } from './formatters';

const backend = new Plugin();

void i18n
    .use(backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: false,
        whitelist: config.languages,
        cleanCode: true,
        ns: ['common'],
        defaultNS: 'common',
        debug: process.env.NODE_ENV !== 'production' && __DEV__ && __DEV__.i18nlog,
        interpolation: {
            escapeValue: false,
            format,
        },
        react: {
            wait: true,
            useSuspense: false,
        },
        detection: {
            order: ['querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag'],
            lookupQuerystring: 'lang',
            lookupCookie: 'lang',
            lookupLocalStorage: 'lang',
            caches: ['localStorage', 'cookie'],
        },
    });

i18n.on('languageChanged', (lng) => {
    moment.locale(lng);
});

export { backend, i18n };
